import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import ModalEnqueteForm from "../modal/enquete_form";
import ModalContentBase from "../modal/modal_content_base";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    circleId: PropTypes.number.isRequired,
    currentUserId: PropTypes.number.isRequired,
  },
  componentDidMount() {},
  render() {
    const previewContent = (
      <span className="btn btn-info mt10 mr10 mb10 pt10 pb10 color-white">
        イベントをつくる
      </span>
    );
    const modalContent = (
      <div style={{ padding: "25px", textAlign: "center" }}>
        <p>どのイベントを作りますか？</p>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <p className="color-white">
            <a
              className="btn btn-info mt10 mr10 pt10 pb10"
              href="/golf/event/new?event_type=1"
            >
              ラウンド会
            </a>
          </p>
          <p className="color-white">
            <a
              className="btn btn-info mt10 mr10 pt10 pb10"
              href="/golf/event/new?event_type=2"
            >
              練習会
            </a>
          </p>
          <p className="color-white">
            <a
              className="btn btn-info mt10 mr10 pt10 pb10"
              href="/golf/event/new?event_type=3"
            >
              懇親会
            </a>
          </p>
        </div>
      </div>
    );

    return (
      <div style={{ display: "flex" }}>
        <ModalContentBase
          previewContent={previewContent}
          modalContent={modalContent}
          // isActive={this.state.isActive}
        />
        <ModalEnqueteForm
          currentUserId={this.props.currentUserId}
          circleId={this.props.circleId}
        />
      </div>
    );
  },
});
